export default () => ({
  entities: 'rules',
  rules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/summary-agenda/resources/data.js